import Hero from '../../components/Hero/Hero'
import Features from '../../components/Features/Features'
import Testimonials from '../../components/Testimonials/Testimonials'
import CTA from '../../components/CTA/CTA'
import SEO from '../../seo/SEO'
import { generateOrganizationSchema, generateWebSiteSchema } from '../../seo/structuredData'
import './Home.css'

const Home = () => {
  const structuredData = [
    generateOrganizationSchema(),
    generateWebSiteSchema()
  ]

  return (
    <>
      <SEO 
        title="Inicio"
        description="Estudio Contable Vanesa Mondejar - Servicios contables profesionales especializados en contabilidad general, asesoramiento impositivo, liquidación de sueldos y consultoría empresarial. Más de 10 años de experiencia brindando soluciones integrales para empresas."
        canonical="https://vanesamondejar.com"
        structuredData={structuredData}
        keywords="estudio contable, vanesa mondejar, estudio contable vanesa mondejar, servicios contables, contador, contadora, asesoramiento impositivo, liquidacion de sueldos, consultoria empresarial, contabilidad general"
      />
      
      <main className="home">
        <Hero 
          title="Servicios Contables Profesionales"
          subtitle="Más de 10 años de experiencia brindando soluciones contables integrales para empresas y profesionales"
        />
        
        <Features 
          title="Nuestros Servicios"
          subtitle="Soluciones contables completas adaptadas a las necesidades de tu empresa"
        />
        
        <Testimonials 
          title="Lo que dicen nuestros clientes"
          subtitle="La confianza de nuestros clientes es nuestro mayor logro"
        />
        
        <CTA 
          title="¿Necesitas asesoramiento contable?"
          subtitle="Contactanos hoy mismo y recibe una consulta personalizada sin compromiso"
        />
      </main>
    </>
  )
}

export default Home
